export default __webpack_public_path__ + "static/media/Pet-Grooming.d6a79ba2.webp";